<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte';
    import License from '../../components/License.svelte';  
    import Token from '../../components/Token.svelte'; 

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">            
            
              <Token />

              
              <div class="container content-container wordpress m-0 p-0">
                <h1 class="text-3xl font-bold mb-4">{$_('docs.wordpress.title')}</h1>
              
                <h2 id="wordpress-introduction" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.introduction.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.introduction.about')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.introduction.about_text')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.introduction.features')}</h3>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.wordpress.introduction.feature_1')}</li>
                  <li>{$_('docs.wordpress.introduction.feature_2')}</li>
                  <li>{$_('docs.wordpress.introduction.feature_3')}</li>
                </ul>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.introduction.requirements')}</h3>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.wordpress.introduction.requirement_1')}</li>
                  <li>{$_('docs.wordpress.introduction.requirement_2')}</li>
                </ul>
              
                <h2 id="wordpress-installation" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.installation.title')}</h2>
                <p class="text-base mb-4">{$_('docs.wordpress.installation.intro')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.installation.video')}</h3>
                <video controls class="w-[600px] mb-4">
                  <source src="https://israel-post.datalogics.co.il/videos/wordpress.mp4" type="video/mp4">
                  <track kind="captions" src="path/to/your/captions.vtt" srclang="he" label="Hebrew Captions" default>
                  {$_('installation.video_unsupported')}
                </video>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.installation.admin_panel')}</h3>
                <ol class="list-decimal list-inside mb-4">
                  <li>
                    {$_('docs.wordpress.installation.admin_step_1.before_link')}
                    <a href="https://docs.datalogics.co.il/downloads/israel-post.zip" target="_blank" class="text-blue-600 hover:underline">
                      {$_('docs.wordpress.installation.admin_step_1.link_text')}
                    </a>
                  </li>
                  <li>{$_('docs.wordpress.installation.admin_step_2')}</li>
                  <li>{$_('docs.wordpress.installation.admin_step_3')}</li>
                  <li>{$_('docs.wordpress.installation.admin_step_4')}</li>
                  <li>{$_('docs.wordpress.installation.admin_step_5')}</li>
                  <li>{$_('docs.wordpress.installation.admin_step_6')}</li>
                  <li>{$_('docs.wordpress.installation.admin_step_7')} {docs_shipping_company_name}</li>
                  <li>{$_('docs.wordpress.installation.admin_step_8')}</li>
                </ol>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.installation.manual')}</h3>
                <ol class="list-decimal list-inside mb-4">
                  <li>
                    {$_('docs.wordpress.installation.manual_step_1.before_link')} {docs_shipping_company_name}
                    <a href="https://docs.datalogics.co.il/downloads/israel-post.zip" target="_blank" class="text-blue-600 hover:underline">
                      {$_('docs.wordpress.installation.manual_step_1.link_text')}
                    </a>
                  </li>
                  <li>{$_('docs.wordpress.installation.manual_step_2')}</li>
                  <li>{$_('docs.wordpress.installation.manual_step_3')}</li>
                </ol>
              
                <h2 id="wordpress-getting-started" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.getting_started.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.getting_started.activation')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.activation_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li>{$_('docs.wordpress.getting_started.activation_step_1')}</li>
                  <li>{$_('docs.wordpress.getting_started.activation_step_2')}</li>
                  <li>{$_('docs.wordpress.getting_started.activation_step_3')} {docs_shipping_company_name} {$_('docs.wordpress.getting_started.activation_step_3_1')}</li>
                  <li>{$_('docs.wordpress.getting_started.activation_step_4')}</li>
                </ol>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.getting_started.configuration')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.configuration_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li>{$_('docs.wordpress.getting_started.config_step_1')}</li>
                  <li>{$_('docs.wordpress.getting_started.config_step_2')}</li>
                  <li>{$_('docs.wordpress.getting_started.config_step_3')} {docs_shipping_company_name} {$_('docs.wordpress.getting_started.config_step_3_1')}</li>
                  <li>{$_('docs.wordpress.getting_started.config_step_4')}</li>
                </ol>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.config_tabs')}</p>
              
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.getting_started.license')}</h4>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.license_intro')}</p>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.wordpress.getting_started.license_step_1')}</li>
                  <li>{$_('docs.wordpress.getting_started.license_step_2')}</li>
                </ul>
              
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.getting_started.account_settings')}</h4>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.account_settings_intro')}</p>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.wordpress.getting_started.account_settings_step_1')}</li>
                </ul>
              
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.getting_started.locations')}</h4>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.locations_intro')}</p>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.wordpress.getting_started.locations_step_1')}</li>
                  <li>{$_('docs.wordpress.getting_started.locations_step_2')}</li>
                  <li>{$_('docs.wordpress.getting_started.locations_step_3')}</li>
                </ul>
              
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.getting_started.global_settings')}</h4>
                <p class="text-base mb-4">{$_('docs.wordpress.getting_started.global_settings_intro')}</p>
                <ul class="list-disc list-inside mb-4">
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_1_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_1')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_2_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_2')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_3_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_3')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_4_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_4')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_5_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_5')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_6_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_6')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_7_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_7')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_8_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_8')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_9_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_9')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_10_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_10')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_11_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_11')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_12_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_12')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_13_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_13')}</li>
                  <li><strong>{$_('docs.wordpress.getting_started.global_setting_14_title')}</strong> {$_('docs.wordpress.getting_started.global_setting_14')}</li>
                </ul>
              
                <h2 id="wordpress-usage" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.usage.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.usage.widgets')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.usage.widgets_intro')}</p>
              
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.usage.orders_page')}</h4>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.wordpress.usage.orders_step_1_title')}</strong> {$_('docs.wordpress.usage.orders_step_1')}</li>
                  <li><strong>{$_('docs.wordpress.usage.orders_step_2_title')}</strong> {$_('docs.wordpress.usage.orders_step_2')}</li>
                  <li><strong>{$_('docs.wordpress.usage.orders_step_3_title')}</strong> {$_('docs.wordpress.usage.orders_step_3')}</li>
                  <li><strong>{$_('docs.wordpress.usage.orders_step_4_title')}</strong> {$_('docs.wordpress.usage.orders_step_4')}</li>
                  <li><strong>{$_('docs.wordpress.usage.orders_step_5_title')}</strong> {$_('docs.wordpress.usage.orders_step_5')}</li>
                </ol>
              
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.usage.order_edit')}</h4>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.wordpress.usage.order_edit_step_1_title')}</strong> {$_('docs.wordpress.usage.order_edit_step_1')}</li>
                  <li><strong>{$_('docs.wordpress.usage.order_edit_step_2_title')}</strong> {$_('docs.wordpress.usage.order_edit_step_2')}</li>
                  <li><strong>{$_('docs.wordpress.usage.order_edit_step_3_title')}</strong> {$_('docs.wordpress.usage.order_edit_step_3')}</li>
                </ol>
              
                <p class="text-base mb-4">{$_('docs.wordpress.usage.widgets_summary')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.usage.shortcodes')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.usage.shortcodes_intro')}</p>
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wordpress.usage.shortcode_title')}</h4>
                <p class="text-base mb-4">{$_('docs.wordpress.usage.shortcode')}</p>
              
                <h2 id="wordpress-customization" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.customization.title')}</h2>
                <p class="text-base mb-4">{$_('docs.wordpress.customization.intro')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.customization.css')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.customization.css_text')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.customization.email')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.customization.email_text')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.customization.translations')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.customization.translations_text')}</p>
              
                <h2 id="wordpress-troubleshooting" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.troubleshooting.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.troubleshooting.common_issues')}</h3>
                <p class="text-base mb-4">
                  <strong>{$_('docs.wordpress.troubleshooting.error_title')}</strong><br>
                  {$_('docs.wordpress.troubleshooting.error_text_1')}<br>
                  {$_('docs.wordpress.troubleshooting.error_text_2')}<br>
                  {$_('docs.wordpress.troubleshooting.error_text_3')}<br>
                  {$_('docs.wordpress.troubleshooting.error_text_4')}<br>
                </p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.troubleshooting.faq')}</h3>
                <ol class="list-decimal list-inside mb-4">
                  <li>
                    <div><strong>{$_('docs.wordpress.troubleshooting.faq_1_q')}</strong></div>
                    <div>{$_('docs.wordpress.troubleshooting.faq_1_a')}</div>
                  </li>
                  <li>
                    <div><strong>{$_('docs.wordpress.troubleshooting.faq_2_q')}</strong></div>
                    <div>{$_('docs.wordpress.troubleshooting.faq_2_a')}</div>
                  </li>
                </ol>
              
                <h2 id="wordpress-support" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.support.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.support.getting_help')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.support.getting_help_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.wordpress.support.help_step_1_title')}</strong> {$_('docs.wordpress.support.help_step_1')}</li>
                  <li><strong>{$_('docs.wordpress.support.help_step_2_title')}</strong> {$_('docs.wordpress.support.help_step_2')}</li>
                </ol>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.support.reporting')}</h3>
                <p class="text-base mb-4">{$_('docs.wordpress.support.reporting_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.wordpress.support.report_step_1_title')}</strong> {$_('docs.wordpress.support.report_step_1')}</li>
                  <li><strong>{$_('docs.wordpress.support.report_step_2_title')}</strong> {$_('docs.wordpress.support.report_step_2')}</li>
                </ol>
              
                <h2 id="wordpress-changelog" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.changelog.title')}</h2>
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wordpress.changelog.version')}</h3>
                <ul class="list-disc list-inside mb-4">
                  <li><strong>{$_('docs.wordpress.changelog.added_title')}</strong> {$_('docs.wordpress.changelog.added')}</li>
                  <li><strong>{$_('docs.wordpress.changelog.updated_title')}</strong> {$_('docs.wordpress.changelog.updated')}</li>
                  <li><strong>{$_('docs.wordpress.changelog.fixed_title')}</strong> {$_('docs.wordpress.changelog.fixed')}</li>
                  <li><strong>{$_('docs.wordpress.changelog.removed_title')}</strong> {$_('docs.wordpress.changelog.removed')}</li>
                </ul>
              
                <h2 id="wordpress-license" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wordpress.license.title')}</h2>
                  
                <License />
            </div>           


        </div>
        
    </div>
</div>
<style>
</style>
